import { Col, Container, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import classes from "./styles.module.scss";
import clsx from "classnames";
import Image from "@/ui/Image";
import PropTypes from "prop-types";
import sourceflowEnums from "@/sourceflow.enums";

export const RecruitmentPageGridSection = ({ className, type }) => {
  const locale = useLocale();
  const pathPrefix = `page.${type}.grid`;

  if (type === null) {
    return null;
  }

  return (
    <div className={clsx(className, classes.grid)}>
      <Container>
        <Row>
          <Col xs={12} md={6} className="p-4 p-md-5 bg-light text-overlay">
            <div className="p-md-3 text-overlay__content">
              <DynamicText path={`${pathPrefix}.section-1.title.${locale}`} tag="h3" className="mb-4" />
              <DynamicHtml path={`${pathPrefix}.section-1.text.${locale}`} className="me-4 mb-4" />
            </div>
            <Image
              className="text-overlay__background"
              img={{ path: `${pathPrefix}.section-1.bg`, src: "/assets/grid/bg.png" }}
              size="650x488"
              alt=""
            />
          </Col>
          <Col xs={12} md={6}>
            <Image
              img={{
                path: `${pathPrefix}.section-1.image`,
                src: `/assets/${type}/grid/1.jpg`,
              }}
              size="650x488"
              alt=""
            />
          </Col>
          <Col xs={12} md={6}>
            <Image
              img={{
                path: `${pathPrefix}.section-2.image`,
                src: `/assets/${type}/grid/2.jpg`,
              }}
              size="650x578"
              alt=""
            />
          </Col>
          <Col xs={12} md={6} className="p-4 p-md-5 bg-light text-overlay">
            <div className="p-md-3 text-overlay__content">
              <DynamicText path={`${pathPrefix}.section-2.title.${locale}`} tag="h3" className="mb-4" />
              <DynamicHtml path={`${pathPrefix}.section-2.text.${locale}`} className="me-4 mb-4" />
            </div>
            <Image
              className="text-overlay__background"
              img={{ path: `${pathPrefix}.section-2.bg`, src: "/assets/grid/bg.png" }}
              size="650x578"
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

RecruitmentPageGridSection.defaultProps = {
  className: "py-4 py-md-5",
  type: null,
};

RecruitmentPageGridSection.propTypes = {
  type: PropTypes.oneOf(sourceflowEnums.config.recruitmentTypes.array),
};
